<template>
  <!-- 申请详情页 -->
  <div class="apply-detail">
    <div class="text-right">
      <a-button slot="extra" @click="goBack">返回</a-button>
    </div>

    <a-card title="审批流程" :loading="loading" class="card">
      <process :process-list="process" />
    </a-card>

    <!-- 基本信息 -->
    <base-info :base-info="baseInfo" :schema="baseInfoSchema" />

    <!-- 申请明细 -->
    <apply-view-detail
      :base-info="baseInfo"
      :credit-info="creditInfo"
      :type="type"
      :limit-extension="limitExtension"
      :attachments="attachments"
      :risk-evaluation="riskEvaluation"
    />

    <!-- 审批意见 -->
    <a-card
      title="审批意见"
      :loading="loading"
      v-if="approvalList.length"
      class="card"
    >
      <approval-remark-list :approval-list="approvalList" />
    </a-card>
  </div>
</template>

<script>
import { getLimitDetail } from '../api'
import { BASE_INFO_SCHEMA, BASE_INFO_EXTRA_SCHEMA } from '../schema'
import Process from '../components/Process.vue'
import BaseInfo from '../components/BaseInfo.vue'
import numeral from 'numeral'
// import ApplyViewDetail from '../components/ApplyDetail/ApplyViewDetail.vue'
import ApplyViewDetail from './ApplyViewDetail.vue'
import ApprovalRemarkList from '../components/ApprovalRemarkList.vue'
import { APPROVAL_STATUS_VALUE_OBJ } from '../const'

export default {
  name: 'apply-detail-page',
  data() {
    return {
      loading: true,
      id: '',
      type: '',
      status: '',
      process: [], // 审批流程
      baseInfo: null, // 基本信息
      creditInfo: null, // 申请明细
      limitExtension: null, //延期表格
      attachments: [], // 附件
      riskEvaluation: '',
    }
  },
  computed: {
    // 详情信息schema
    baseInfoSchema() {
      const status = this.status
      if (
        status == APPROVAL_STATUS_VALUE_OBJ.INIT ||
        status == APPROVAL_STATUS_VALUE_OBJ.PADDING ||
        status == APPROVAL_STATUS_VALUE_OBJ.PASSED
      ) {
        return Object.assign({}, BASE_INFO_SCHEMA, BASE_INFO_EXTRA_SCHEMA)
      }
      return BASE_INFO_SCHEMA
    },
    approvalList() {
      const process = this.process
      const list = []
      process.forEach((item, index) => {
        if (index == 0) return
        if (item.approvePerson) {
          list.push({ id: item.id, ...item.approvePerson })
        }
      })
      return list
    },
  },
  created() {
    const { type, status } = this.$route.query
    const { id } = this.$route.params
    if (id) {
      this.id = id
      this.type = type
      this.status = status
      this._getLimitDetail(id)
    }
  },
  methods: {
    resetAmount(num) {
      return numeral(num).format('0.00')
    },
    async _getLimitDetail(id) {
      try {
        const { data } = await getLimitDetail(id)
        if (data.baseInfo.riskWarning !== '') {
          this.$warning({
            title: '提示',
            content: '重要提示：该申请客户存在风险信息',
          })
        }
        if (data) {
          for (let key in data) {
            if (typeof this[key] !== 'undefined') {
              this[key] = data[key]
            }
          }
        }
        const minus =
          Number(this.resetAmount(this.baseInfo.totalCreditLimit)) -
          Number(this.baseInfo.groupTotalAmount)
        this.baseInfo.groupExposure = minus
        Object.assign(this.baseInfo, {
          groupExposure: minus,
          financeTarget: '查询',
          kpiTarget: '查询',
        })
        if (this.baseInfo.companyType === 1) {
          delete this.baseInfo.exposure
        } else {
          delete this.baseInfo.groupExposure
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  components: {
    Process,
    BaseInfo,
    ApplyViewDetail,
    ApprovalRemarkList,
  },
}
</script>

<style></style>
